import React, { useState } from 'react';
// import { useIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import Icons from '../../components/Icons/Icons';

import css from './FAQPage.module.css';

function FAQSection(props) {
  const { faqsData } = props;

  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = index => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className={css.faqContentWrapper}>
      <div className={css.faqContent}>
        {faqsData.map((faq, index) => (
          <div
            key={index}
            className={classNames(css.faqCard, {
              [css.activeFAQ]: activeIndex === index,
            })}
            onClick={() => handleAccordionClick(index)}
          >
            <div className={css.faqBody}>
              <span className={css.faqHeading}>{faq?.question} </span>{' '}
              {activeIndex === index && <div className={css.faqDescription}>{faq?.answer}</div>}
            </div>
            <span className={css.faqIcon}>
              {activeIndex === index ? (
                <span>
                  <Icons name="faqOpenIcon" />
                </span>
              ) : (
                <span>
                  <Icons name="faqCloseIcon" />
                </span>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQSection;
